/* ============================================================
   JURIS DRONE 2026 — Vanilla JS init (carousel, reveals, parallax, counters)
   ============================================================ */
(function () {
  "use strict";
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  /* ---------------- CATEGORY RAIL (infinite drag carousel) ---------------- */
  let carouselRAF = null;
  function setupCarousel() {
    const rail = $("#catRail");
    if (!rail) return;
    const track = rail.querySelector(".rail-track");
    if (!track) return;
    // duplicate content for seamless loop
    if (!track.dataset.doubled) {
      track.innerHTML += track.innerHTML;
      track.dataset.doubled = "1";
    }
    let half = 0;
    let pos = 0, dragging = false, startX = 0, basePos = 0, lastX = 0, vel = 0, hovering = false, moved = false, downTime = 0;
    const SPEED = 0.35;
    const norm = (p) => { if (!half) return p; while (p < 0) p += half; while (p >= half) p -= half; return p; };
    const recalc = () => {
      const newHalf = track.scrollWidth / 2;
      if (newHalf > 0) half = newHalf;
    };
    const tick = () => {
      if (!half) recalc();
      const m = +getComputedStyle(document.documentElement).getPropertyValue("--motion") || 1;
      if (!dragging && half) {
        if (Math.abs(vel) > 0.06) { pos = norm(pos + vel); vel *= 0.92; }
        else if (!hovering && m > 0) pos = norm(pos + SPEED * m);
      }
      track.style.transform = `translate3d(${-pos}px,0,0)`;
      carouselRAF = requestAnimationFrame(tick);
    };
    // recalc once all images in track have loaded
    const imgs = track.querySelectorAll("img");
    let loaded = 0;
    const onImgLoad = () => { loaded++; recalc(); if (loaded >= imgs.length) recalc(); };
    imgs.forEach(im => {
      if (im.complete && im.naturalWidth) onImgLoad();
      else { im.addEventListener("load", onImgLoad, { once: true }); im.addEventListener("error", onImgLoad, { once: true }); }
    });

    const DRAG_THRESHOLD = 14; // px : seuil pour considérer un vrai drag
    const QUICK_CLICK_MS = 250; // ms : sous ce temps, toujours traiter comme clic

    rail.addEventListener("pointerenter", () => (hovering = true));
    rail.addEventListener("pointerleave", () => (hovering = false));
    rail.addEventListener("pointerdown", (e) => {
      // Ignorer les clics droits/middle clicks
      if (e.button !== 0) return;
      dragging = true; moved = false; downTime = performance.now();
      startX = lastX = e.clientX; basePos = pos; vel = 0;
      // Ne PAS appeler setPointerCapture pour ne pas bloquer le clic naturel
    });
    rail.addEventListener("selectstart", (e) => { if (moved) e.preventDefault(); });
    rail.addEventListener("dragstart", (e) => e.preventDefault());
    rail.addEventListener("pointermove", (e) => {
      if (!dragging) return;
      const dx = e.clientX - startX;
      if (Math.abs(dx) > DRAG_THRESHOLD) {
        // Une fois qu'on a dépassé le seuil, on est en vrai drag
        moved = true;
        rail.classList.add("dragging");
        // Capture le pointer pour la suite du drag
        try { rail.setPointerCapture(e.pointerId); } catch (_) {}
      }
      if (moved) {
        pos = norm(basePos - dx);
        vel = -(e.clientX - lastX); lastX = e.clientX;
      }
    });
    const end = (e) => {
      if (!dragging) return;
      const elapsed = performance.now() - downTime;
      dragging = false;
      rail.classList.remove("dragging");
      // Si interaction rapide ET courte distance → c'est un clic, pas un drag
      if (elapsed < QUICK_CLICK_MS && Math.abs(e.clientX - startX) < DRAG_THRESHOLD) {
        moved = false;
      }
      try { rail.releasePointerCapture(e.pointerId); } catch (_) {}
    };
    rail.addEventListener("pointerup", end);
    rail.addEventListener("pointercancel", end);
    // Bloque le clic UNIQUEMENT si un vrai drag a eu lieu
    rail.addEventListener("click", (e) => {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
      }
      moved = false;
    }, true);

    window.addEventListener("resize", recalc);
    if (!carouselRAF) carouselRAF = requestAnimationFrame(tick);
  }

  /* ---------------- REVEAL-ON-SCROLL ---------------- */
  let revealObserver;
  function setupReveal() {
    if (!("IntersectionObserver" in window)) return;
    revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add("in"); revealObserver.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    $$(".jd2026 [data-reveal]:not(.in)").forEach((el) => revealObserver.observe(el));
  }

  /* ---------------- HERO PARALLAX ---------------- */
  function setupHeroParallax() {
    const media = $("#heroMedia"); if (!media) return;
    const img = media.querySelector("img"); const hero = $("#hero");
    if (!img || !hero) return;
    let mx = 0, my = 0, sy = 0, raf = null;
    const apply = () => {
      raf = null;
      const m = +getComputedStyle(document.documentElement).getPropertyValue("--motion") || 1;
      img.style.transform = `translate3d(${mx * 14 * m}px, ${sy * 0.18 * m + my * 12 * m}px, 0) scale(${1 + 0.04 * m})`;
    };
    const queue = () => { if (!raf) raf = requestAnimationFrame(apply); };
    window.addEventListener("scroll", () => { sy = window.scrollY; queue(); }, { passive: true });
    hero.addEventListener("mousemove", (e) => {
      const r = hero.getBoundingClientRect();
      mx = (e.clientX - r.left) / r.width - 0.5; my = (e.clientY - r.top) / r.height - 0.5; queue();
    });
    hero.addEventListener("mouseleave", () => { mx = 0; my = 0; queue(); });
  }

  /* ---------------- STAT COUNTERS ---------------- */
  function animateCounters() {
    const band = $("#statBand"); if (!band) return;
    if (!("IntersectionObserver" in window)) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting || band.dataset.done) return;
        band.dataset.done = "1"; io.disconnect();
        $$(".num", band).forEach((numEl) => {
          const target = +numEl.dataset.count; const suffix = numEl.dataset.suffix || "";
          const vEl = numEl.querySelector(".v"); const dur = 1500; const t0 = performance.now();
          const tick = (t) => {
            const p = Math.min(1, (t - t0) / dur); const eased = 1 - Math.pow(1 - p, 3);
            vEl.textContent = Math.round(target * eased);
            if (p < 1) requestAnimationFrame(tick);
            else { vEl.textContent = target; numEl.insertAdjacentHTML("beforeend", `<span class="u">${suffix.trim()}</span>`); }
          };
          requestAnimationFrame(tick);
        });
      });
    }, { threshold: 0.4 });
    io.observe(band);
  }

  /* ---------------- HEADER SCROLL + MARQUEE DOUBLE ---------------- */
  function setupHeader() {
    const head = $(".site-head");
    if (head) {
      // Force position:fixed (le grid body de Dawn casse position:sticky)
      head.style.position = "fixed";
      head.style.top = "0";
      head.style.left = "0";
      head.style.right = "0";
      head.style.zIndex = "90";

      // Compense l'absence de hauteur en flow par un padding-top sur main
      // (sauf sur la home où le hero est volontairement full-bleed sous le header)
      const main = $("main#MainContent") || $("main");
      const isHome = document.body.classList.contains("template-index");
      if (main && !isHome) {
        const h = head.offsetHeight || 110;
        main.style.paddingTop = h + "px";
      }

      const onScroll = () => head.classList.toggle("scrolled", window.scrollY > 40);
      window.addEventListener("scroll", onScroll, { passive: true }); onScroll();
    }
    const marq = $(".site-head .marq");
    if (marq && !marq.dataset.doubled) { marq.innerHTML += marq.innerHTML; marq.dataset.doubled = "1"; }
  }

  /* ---------------- SIDE DRAWERS (burger + cart) ---------------- */
  function setupSideDrawers() {
    const scrim = $("#jdScrim");
    const burger = $("#jdBurger");
    const cart = $("#jdCart");
    if (!scrim || (!burger && !cart)) return;
    if (scrim.dataset.inited === "1") return;
    scrim.dataset.inited = "1";

    const syncAria = (el, isOpen) => {
      const id = el.id;
      $$(`[aria-controls="${id}"]`).forEach(btn => btn.setAttribute("aria-expanded", isOpen ? "true" : "false"));
    };
    const openDrawer = (el) => {
      if (!el) return;
      el.classList.add("is-open");
      el.setAttribute("aria-hidden", "false");
      scrim.classList.add("is-open");
      scrim.setAttribute("aria-hidden", "false");
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
      syncAria(el, true);
    };
    const closeAll = () => {
      [burger, cart].forEach(d => { if (d) { d.classList.remove("is-open"); d.setAttribute("aria-hidden", "true"); syncAria(d, false); } });
      scrim.classList.remove("is-open");
      scrim.setAttribute("aria-hidden", "true");
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
      // Ferme aussi le mega-menu si ouvert
      $$(".has-mega.is-open").forEach(m => {
        m.classList.remove("is-open");
        const t = m.querySelector("[data-jd-mega-toggle]");
        if (t) t.setAttribute("aria-expanded", "false");
      });
    };
    const toggleDrawer = (el) => {
      if (!el) return;
      if (el.classList.contains("is-open")) closeAll();
      else { closeAll(); openDrawer(el); }
    };

    $$("[data-jd-burger-toggle]").forEach(b => b.addEventListener("click", (e) => { e.preventDefault(); toggleDrawer(burger); }));
    $$("[data-jd-cart-toggle]").forEach(b => b.addEventListener("click", (e) => {
      e.preventDefault();
      if (!cart.classList.contains("is-open")) refreshCartDrawer();
      toggleDrawer(cart);
    }));
    // Hooks globaux : ouvrir le tiroir (sans réseau) ou ouvrir + refetch, depuis n'importe quelle fiche (pfAddToCart)
    window.jdOpenDrawer = function(){ if (!cart) return; showCartLoading(); if (!cart.classList.contains("is-open")) openDrawer(cart); };
    window.jdOpenCart = function(){ if (!cart) return; refreshCartDrawer(); if (!cart.classList.contains("is-open")) openDrawer(cart); };
    scrim.addEventListener("click", closeAll);
    document.addEventListener("keydown", (e) => { if (e.key === "Escape") closeAll(); });

    // Mega-menu : toggle click + escape + click outside
    $$("[data-jd-mega-toggle]").forEach(trigger => {
      trigger.addEventListener("click", (e) => {
        e.preventDefault();
        const parent = trigger.closest("[data-jd-mega]");
        if (!parent) return;
        const isOpen = parent.classList.toggle("is-open");
        trigger.setAttribute("aria-expanded", isOpen ? "true" : "false");
        // Ferme les autres mega ouverts
        $$("[data-jd-mega].is-open").forEach(p => { if (p !== parent) { p.classList.remove("is-open"); p.querySelector("[data-jd-mega-toggle]")?.setAttribute("aria-expanded", "false"); } });
      });
    });
    document.addEventListener("click", (e) => {
      if (!e.target.closest("[data-jd-mega]")) {
        $$("[data-jd-mega].is-open").forEach(p => {
          p.classList.remove("is-open");
          p.querySelector("[data-jd-mega-toggle]")?.setAttribute("aria-expanded", "false");
        });
      }
    });

    // Cart qty + remove via Shopify Cart AJAX API
    cart && cart.addEventListener("click", async (e) => {
      const clearBtn = e.target.closest("[data-jd-cart-clear]");
      if (clearBtn) {
        e.preventDefault();
        if (!window.confirm("Vider entièrement le panier ?")) return;
        clearBtn.disabled = true;
        try {
          await fetch("/cart/clear.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" } });
        } catch (_) {}
        refreshCartDrawer();
        return;
      }
      const minus = e.target.closest("[data-jd-cart-minus]");
      const plus = e.target.closest("[data-jd-cart-plus]");
      const remove = e.target.closest("[data-jd-cart-remove]");
      if (!minus && !plus && !remove) return;
      e.preventDefault();
      const key = (minus || plus || remove).getAttribute("data-jd-cart-minus")
                || (plus && plus.getAttribute("data-jd-cart-plus"))
                || (remove && remove.getAttribute("data-jd-cart-remove"));
      const li = cart.querySelector(`[data-key="${key}"]`);
      if (!li) return;
      const qtyEl = li.querySelector(".jd-cart__qty span");
      let qty = parseInt(qtyEl?.textContent || "1", 10);
      if (minus) qty = Math.max(0, qty - 1);
      if (plus) qty = qty + 1;
      if (remove) qty = 0;
      try {
        const r = await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ id: key, quantity: qty, sections: "jd-header", sections_url: "/" })
        });
        const json = await r.json();
        if (json && json.sections) renderCartDrawer(json.sections["jd-header"]);
        else refreshCartDrawer();
      } catch (_) { refreshCartDrawer(); }
    });
  }

  // Affiche un état de chargement (barre + skeleton si vide) pendant que le tiroir se remplit.
  function showCartLoading() {
    const cart = $("#jdCart");
    if (!cart) return;
    cart.classList.add("jd-cart--loading");
    const body = cart.querySelector(".jd-cart__body");
    if (body && !body.querySelector(".jd-cart__item")) {
      const s = '<li class="jd-cart__item jd-cart__item--skel"><span class="jd-skel jd-skel--thumb"></span><span class="jd-skel-lines"><span class="jd-skel jd-skel--l1"></span><span class="jd-skel jd-skel--l2"></span></span></li>';
      body.innerHTML = '<ul class="jd-cart__items">' + s + s + '</ul>';
    }
  }

  // Applique au tiroir un HTML de section jd-header (frais) — AUCUNE requête réseau.
  function renderCartDrawer(html) {
    const cart = $("#jdCart");
    if (!cart || !html) return;
    const wasLoading = cart.classList.contains("jd-cart--loading");
    const prevCount = cart.querySelector(".jd-cart__count")?.textContent || "";
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    const newCart = tmp.querySelector("#jdCart");
    const newCount = tmp.querySelector(".cart-btn .count");
    if (newCart) {
      const wasOpen = cart.classList.contains("is-open");
      cart.querySelector(".jd-cart__body")?.replaceWith(newCart.querySelector(".jd-cart__body"));
      const oldFoot = cart.querySelector(".jd-cart__foot");
      const newFoot = newCart.querySelector(".jd-cart__foot");
      if (oldFoot && newFoot) oldFoot.replaceWith(newFoot);
      else if (newFoot) cart.appendChild(newFoot);
      else if (oldFoot) oldFoot.remove();
      const countEl = cart.querySelector(".jd-cart__count");
      const newCountEl = newCart.querySelector(".jd-cart__count");
      if (countEl && newCountEl) {
        countEl.textContent = newCountEl.textContent;
        if (prevCount && prevCount !== newCountEl.textContent) { countEl.classList.remove("jd-bump"); void countEl.offsetWidth; countEl.classList.add("jd-bump"); setTimeout(function(){ countEl.classList.remove("jd-bump"); }, 480); }
      }
      if (wasOpen) cart.classList.add("is-open");
    }
    const headerCount = document.querySelector(".cart-btn .count");
    if (headerCount && newCount) {
      headerCount.textContent = newCount.textContent;
      headerCount.hidden = (parseInt(newCount.textContent, 10) || 0) === 0;
    } else if (headerCount) {
      headerCount.hidden = true;
    }
    cart.classList.remove("jd-cart--loading");
    if (wasLoading) { cart.classList.add("jd-cart--in"); setTimeout(function(){ cart.classList.remove("jd-cart--in"); }, 700); }
  }

  // Récupère le tiroir frais via l'API Cart AJAX (jamais caché) puis le rend. Pour ouverture manuelle / vidage.
  async function refreshCartDrawer() {
    if (!$("#jdCart")) return;
    try {
      const r = await fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify({ updates: {}, sections: "jd-header", sections_url: "/" }) });
      if (!r.ok) return;
      const json = await r.json();
      renderCartDrawer(json.sections && json.sections["jd-header"]);
    } catch (_) {}
  }

  // Hooks globaux pour les fiches produit (pfAddToCart) : rendu direct (sans réseau) + refetch
  window.jdRenderCart = renderCartDrawer;
  window.jdRefreshCart = refreshCartDrawer;

  // Listen for any add-to-cart form submissions in the page to refresh the drawer
  document.addEventListener("submit", async (e) => {
    const form = e.target.closest("form[action*='/cart/add']");
    if (!form) return;
    e.preventDefault();
    const fd = new FormData(form);
    fd.append("sections", "jd-header");
    fd.append("sections_url", "/");
    // Ouverture immédiate du tiroir (optimiste) + état de chargement, le contenu frais arrive en 1 requête
    if (window.jdOpenDrawer) window.jdOpenDrawer();
    else {
      const cart = $("#jdCart");
      const scrim = $("#jdScrim");
      if (cart && scrim) {
        cart.classList.add("is-open"); cart.setAttribute("aria-hidden", "false");
        scrim.classList.add("is-open"); scrim.setAttribute("aria-hidden", "false");
        document.documentElement.style.overflow = "hidden";
        document.body.style.overflow = "hidden";
      }
    }
    try {
      const r = await fetch("/cart/add.js", { method: "POST", headers: { "Accept": "application/json" }, body: fd });
      const json = await r.json().catch(() => null);
      if (json && json.sections) renderCartDrawer(json.sections["jd-header"]);
      else await refreshCartDrawer();
    } catch (_) {}
  });

  /* ---------------- SEARCH DRAWER inline + predictive search ---------------- */
  function setupSearch() {
    const drawer = $("#jdSearch");
    if (!drawer || drawer.dataset.inited === "1") return;
    drawer.dataset.inited = "1";
    const input = $("#jdSearchInput");
    const hints = drawer.querySelector("[data-jd-search-hints]");
    const results = drawer.querySelector("[data-jd-search-results]");
    const toggles = $$("[data-jd-search-toggle]");
    const open = () => {
      drawer.classList.add("is-open");
      drawer.setAttribute("aria-hidden", "false");
      setTimeout(() => input && input.focus(), 200);
    };
    const close = () => {
      drawer.classList.remove("is-open");
      drawer.setAttribute("aria-hidden", "true");
    };
    const toggle = () => drawer.classList.contains("is-open") ? close() : open();
    toggles.forEach(b => b.addEventListener("click", (e) => { e.preventDefault(); toggle(); }));
    document.addEventListener("keydown", (e) => { if (e.key === "Escape" && drawer.classList.contains("is-open")) close(); });
    document.addEventListener("click", (e) => {
      if (!drawer.classList.contains("is-open")) return;
      if (drawer.contains(e.target)) return;
      if (e.target.closest("[data-jd-search-toggle]")) return;
      close();
    });

    // Predictive search
    if (!input || !results) return;
    const fmtMoney = (cents) => (cents / 100).toLocaleString("fr-FR", { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + " €";
    let lastQuery = "";
    let ctrl = null;
    let debounceTimer = null;

    // Signal d'accessoire FIABLE : le product_type ("Accessoires"). La boutique
    // catégorise correctement (Drone PRO, Caméra… vs Accessoires). Mots-clés du
    // titre = filet de sécurité si une fiche a un type vide/mal renseigné.
    const ACCESSORY_RE = /\b(accessoires?|batteries?|chargeurs?|h[ée]lices?|[ée]tuis?|sacoche|sac|housse|c[âa]bles?|filtres?|protection|prot[èe]ge|support|plaque|cartes? ?(sd|m[ée]moire)|micro ?sd|adaptateur|capuchon|pare-soleil|bandouli[èe]re|courroie|cordon)\b/i;
    const norm = (s) => (s || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");
    // Marque en tête de titre, à ignorer pour la pertinence ("DJI Mavic" → "mavic").
    const BRAND_RE = /^(dji|gopro|insta ?360|hasselblad|ryze|tello)\s+/;
    const PENALTY_ACCESSORY = 1000; // séparation STRICTE : un accessoire passe toujours sous un produit principal

    // Score un produit : produits principaux en haut, accessoires (et ruptures) en bas.
    const scoreProduct = (p, qNorm, qTokens) => {
      const rawTitle = norm(p.title);
      const title = rawTitle.replace(BRAND_RE, ""); // sans la marque en préfixe
      const type = norm(p.type || p.product_type);
      const isAccessory = type.indexOf("accessoire") > -1 || ACCESSORY_RE.test(rawTitle);
      let s = 0;
      if (title === qNorm || rawTitle === qNorm) s += 100;
      else if (title.startsWith(qNorm) || rawTitle.startsWith(qNorm)) s += 60;
      else if (title.split(/\s+/).some(w => qTokens.some(t => w.startsWith(t)))) s += 30;
      if (qTokens.length && qTokens.every(t => rawTitle.includes(t))) s += 15;
      if (isAccessory) s -= PENALTY_ACCESSORY;  // produit principal d'abord, toujours
      if (p.available === false) s -= 80;         // dispo avant rupture
      return s;
    };

    // Tri stable : on respecte l'ordre Shopify à score égal.
    const rankProducts = (products, query) => {
      const qNorm = norm(query);
      const qTokens = qNorm.split(/\s+/).filter(Boolean);
      return products
        .map((p, i) => ({ p, i, s: scoreProduct(p, qNorm, qTokens) }))
        .sort((a, b) => b.s - a.s || a.i - b.i)
        .map(x => x.p);
    };

    const renderResults = (products, query) => {
      if (products.length === 0) {
        results.innerHTML = `<div class="jd-search__empty">Aucun produit trouvé pour "<strong>${query}</strong>".</div>`;
        return;
      }
      const itemsHtml = products.map(p => {
        const img = p.featured_image?.url || p.image || "";
        const price = p.price ? fmtMoney(Math.round(parseFloat(p.price) * 100)) : "";
        const vendor = p.vendor || "";
        return `<a class="jd-search__item" href="${p.url}">
          <span class="jd-search__thumb">${img ? `<img src="${img}" alt="" loading="lazy">` : ""}</span>
          <span class="jd-search__info">
            <span class="jd-search__title">${p.title}</span>
            ${vendor ? `<span class="jd-search__vendor">${vendor}</span>` : ""}
          </span>
          <span class="jd-search__price">${price}</span>
        </a>`;
      }).join("");
      results.innerHTML = `
        <div class="jd-search__results-head">Produits — ${products.length}</div>
        <div class="jd-search__list">${itemsHtml}</div>
        <a class="jd-search__viewall" href="/search?q=${encodeURIComponent(query)}&type=product">Voir tous les résultats pour "${query}" →</a>
      `;
    };

    const search = async (q) => {
      if (q.length < 2) {
        results.hidden = true;
        hints.hidden = false;
        return;
      }
      if (q === lastQuery) return;
      lastQuery = q;
      results.hidden = false;
      hints.hidden = true;
      results.innerHTML = `<div class="jd-search__loader">Recherche…</div>`;
      try {
        if (ctrl) ctrl.abort();
        ctrl = new AbortController();
        const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last`;
        const r = await fetch(url, { signal: ctrl.signal, headers: { "Accept": "application/json" } });
        if (!r.ok) throw new Error("Search failed");
        const data = await r.json();
        const products = data.resources?.results?.products || [];
        // Produit avant accessoire, nouveautés/pertinence en tête, puis on garde le top 8.
        renderResults(rankProducts(products, q).slice(0, 8), q);
      } catch (e) {
        if (e.name === "AbortError") return;
        results.innerHTML = `<div class="jd-search__empty">Erreur de recherche, réessaie.</div>`;
      }
    };

    let activeIdx = -1;
    input.addEventListener("input", () => {
      const q = input.value.trim();
      activeIdx = -1;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => search(q), 220);
    });

    // Navigation clavier dans la liste de suggestions (↑ ↓ Entrée)
    const setActive = (idx) => {
      const items = $$(".jd-search__item", results);
      if (!items.length) return;
      activeIdx = (idx + items.length) % items.length;
      items.forEach((el, i) => el.classList.toggle("is-active", i === activeIdx));
      items[activeIdx].scrollIntoView({ block: "nearest" });
    };
    input.addEventListener("keydown", (e) => {
      const items = $$(".jd-search__item", results);
      if (results.hidden || !items.length) { activeIdx = -1; return; }
      if (e.key === "ArrowDown") { e.preventDefault(); setActive(activeIdx + 1); }
      else if (e.key === "ArrowUp") { e.preventDefault(); setActive(activeIdx - 1); }
      else if (e.key === "Enter" && activeIdx > -1) { e.preventDefault(); items[activeIdx].click(); }
    });
    // Reset when drawer closes
    toggles.forEach(b => b.addEventListener("click", () => {
      setTimeout(() => {
        if (!drawer.classList.contains("is-open")) {
          input.value = "";
          results.hidden = true;
          results.innerHTML = "";
          hints.hidden = false;
          lastQuery = "";
        }
      }, 50);
    }));
  }

  /* ---------------- HERO TITLE RISE ---------------- */
  function liftHero() {
    requestAnimationFrame(() => { const h = $("#hero"); if (h) h.classList.add("lit"); });
  }

  /* ---------------- PROMO BANNER CAROUSEL (slide-by-slide + dots + autoplay) ---------------- */
  function setupPromoCarousel() {
    const mains = $$("[data-jd-banner-main]");
    mains.forEach(main => {
      if (main.dataset.inited === "1") return;
      main.dataset.inited = "1";
      const slides = $$(".jd-banner--main", main);
      if (slides.length === 0) return;
      const dots = $$("[data-jd-banner-dot]", main);
      const prev = main.querySelector("[data-jd-banner-prev]");
      const next = main.querySelector("[data-jd-banner-next]");
      let i = 0, timer = null;
      const show = (idx) => {
        i = ((idx % slides.length) + slides.length) % slides.length;
        slides.forEach((s, k) => s.classList.toggle("is-active", k === i));
        dots.forEach((d, k) => d.classList.toggle("is-active", k === i));
      };
      const start = () => {
        if (timer || slides.length < 2) return;
        timer = setInterval(() => show(i + 1), 6000);
      };
      const stop = () => { if (timer) { clearInterval(timer); timer = null; } };
      prev?.addEventListener("click", () => { show(i - 1); stop(); start(); });
      next?.addEventListener("click", () => { show(i + 1); stop(); start(); });
      dots.forEach(d => d.addEventListener("click", () => { show(+d.getAttribute("data-jd-banner-dot")); stop(); start(); }));
      main.addEventListener("pointerenter", stop);
      main.addEventListener("pointerleave", start);
      // Swipe
      let sx = 0, mx = 0, down = false;
      main.addEventListener("pointerdown", (e) => { down = true; sx = e.clientX; mx = 0; });
      main.addEventListener("pointermove", (e) => { if (down) mx = e.clientX - sx; });
      main.addEventListener("pointerup", () => { if (!down) return; down = false; if (Math.abs(mx) > 40) { show(i + (mx < 0 ? 1 : -1)); stop(); start(); } });
      show(0); start();
    });
  }

  /* ---------------- BESTSELLERS FALLBACK (cache page bloquée) ---------------- */
  async function patchBestsellers() {
    const grid = document.querySelector(".jd2026 .product-grid");
    if (!grid) return;
    if (grid.querySelector(".pcard")) return; /* cartes serveur présentes: ne rien réécrire */
    const wantedHandles = [
      "dji-matrice-4e-1",
      "dji-matrice-30",
      "dji-matrice-400-rtk",
      "mavic-4-pro",
      "dji-inspire-3",
      "dji-mini-5-pro"
    ];
    const presentHandles = [...grid.querySelectorAll(".pcard")].map(a => {
      const m = a.getAttribute("href")?.match(/\/products\/([^/?#]+)/);
      return m ? m[1] : null;
    }).filter(Boolean);
    const missing = wantedHandles.filter(h => !presentHandles.includes(h));
    if (!missing.length) return;
    const eur = (cents) => (cents / 100).toLocaleString("fr-FR", { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + " €";
    const cards = await Promise.all(missing.map(async (h) => {
      try {
        const r = await fetch(`/products/${h}.js`);
        if (!r.ok) return null;
        const p = await r.json();
        const img = p.featured_image
          ? (p.featured_image.startsWith("//") ? p.featured_image : "//" + p.featured_image.replace(/^https?:\/\//, ""))
          : "";
        const type = (p.type || "Drone").toUpperCase();
        const price = eur(p.price);
        return `<article class="pcard" data-reveal>
          <a class="ph" href="/products/${p.handle}" aria-label="${p.title}">
            <img src="${img}&width=600" alt="${p.title}" loading="lazy" decoding="async" width="600" height="450">
          </a>
          <a class="info" href="/products/${p.handle}">
            <span class="ptype">${type}</span>
            <h3>${p.title}</h3>
            <div class="prow"><div class="pricegrp"><span class="priceline"><span class="price">${price}</span></span></div><span class="cta-dot" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M13 6l6 6-6 6"/></svg></span></div>
          </a>
        </article>`;
      } catch (e) { return null; }
    }));
    // Reorder: prepend missing in their original positions
    const original = wantedHandles.map(h => {
      const i = presentHandles.indexOf(h);
      if (i >= 0) return grid.querySelectorAll(".pcard")[i].outerHTML;
      const mi = missing.indexOf(h);
      return cards[mi] || "";
    }).filter(Boolean);
    grid.innerHTML = original.join("");
    // Re-trigger reveal on new cards
    if ("IntersectionObserver" in window && revealObserver) {
      grid.querySelectorAll("[data-reveal]:not(.in)").forEach(el => revealObserver.observe(el));
    } else {
      grid.querySelectorAll("[data-reveal]").forEach(el => el.classList.add("in"));
    }
  }

  /* ---------------- INIT ---------------- */
  function safe(name, fn) { try { fn(); } catch (err) { console.warn('[jd-2026] ' + name + ' failed:', err); } }
  function init() {
    safe('setupHeader', setupHeader);
    safe('setupSideDrawers', setupSideDrawers);
    safe('setupSearch', setupSearch);
    safe('setupReveal', setupReveal);
    safe('setupCarousel', setupCarousel);
    safe('setupPromoCarousel', setupPromoCarousel);
    safe('setupHeroParallax', setupHeroParallax);
    safe('animateCounters', animateCounters);
    safe('liftHero', liftHero);
    safe('patchBestsellers', patchBestsellers);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();

  /* ---------------- BURGER + CART DELEGATION FALLBACK ----------------
     Si pour une raison X la première init des drawers a foiré, ce listener
     global garantit que le clic sur le burger/cart/scrim ouvre/ferme. */
  document.addEventListener('click', function(e){
    const burgerTrigger = e.target.closest('[data-jd-burger-toggle]');
    const cartTrigger = e.target.closest('[data-jd-cart-toggle]');
    const scrimClick = e.target.closest('#jdScrim, [data-jd-scrim]');
    if (!burgerTrigger && !cartTrigger && !scrimClick) return;
    const scrim = document.getElementById('jdScrim');
    const burger = document.getElementById('jdBurger');
    const cart = document.getElementById('jdCart');
    if (!scrim || (!burger && !cart)) return;
    // Si l'init principal a tagué le scrim, on laisse le handler natif gérer
    if (scrim.dataset.inited === '1') return;
    e.preventDefault();
    const target = burgerTrigger ? burger : (cartTrigger ? cart : null);
    const closeAll = () => {
      [burger, cart].forEach(d => { if (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden','true'); } });
      scrim.classList.remove('is-open');
      scrim.setAttribute('aria-hidden','true');
      document.documentElement.style.overflow='';
      document.body.style.overflow='';
    };
    if (scrimClick) { closeAll(); return; }
    if (!target) return;
    const wasOpen = target.classList.contains('is-open');
    closeAll();
    if (!wasOpen) {
      target.classList.add('is-open');
      target.setAttribute('aria-hidden','false');
      scrim.classList.add('is-open');
      scrim.setAttribute('aria-hidden','false');
      document.documentElement.style.overflow='hidden';
      document.body.style.overflow='hidden';
    }
  }, true);
  document.addEventListener('keydown', function(e){
    if (e.key !== 'Escape') return;
    const scrim = document.getElementById('jdScrim');
    if (!scrim || !scrim.classList.contains('is-open')) return;
    if (scrim.dataset.inited === '1') return;
    document.querySelectorAll('.jd-side-drawer.is-open').forEach(d => { d.classList.remove('is-open'); d.setAttribute('aria-hidden','true'); });
    scrim.classList.remove('is-open');
    scrim.setAttribute('aria-hidden','true');
    document.documentElement.style.overflow='';
    document.body.style.overflow='';
  });

  // Re-init for shopify section reloads (theme editor)
  document.addEventListener("shopify:section:load", () => {
    setupHeader(); setupSideDrawers(); setupSearch(); setupReveal(); setupCarousel(); setupPromoCarousel(); setupHeroParallax(); animateCounters(); liftHero();
  });
})();

/* ---- FIX VIDÉOS AUTOPLAY (Safari/WebKit) ----
   Safari ne tente l'autoplay qu'une fois : si la vidéo (preload="none") n'a
   pas encore de données à ce moment-là, elle reste figée sur une image.
   Idem au retour via bfcache. On force donc play() quand la vidéo entre
   dans le viewport, et on relance les vidéos visibles au pageshow. */
(function(){
  function kick(v){
    if (v.preload === 'none') v.preload = 'metadata';
    if (v.paused){
      if (v.readyState === 0){ try { v.load(); } catch(e){} }
      var p = v.play(); if (p && p.catch) p.catch(function(){});
    }
  }
  function inViewport(v){
    var r = v.getBoundingClientRect();
    return r.bottom > 0 && r.top < (window.innerHeight || 0) && r.width > 0;
  }
  function init(){
    var vids = Array.prototype.slice.call(document.querySelectorAll('video[autoplay], video[data-jd-autoplay]'));
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)){ vids.forEach(kick); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){ kick(e.target); io.unobserve(e.target); }
      });
    }, { rootMargin: '30% 0px' });
    vids.forEach(function(v){ if (v.dataset.jdKick !== '1'){ v.dataset.jdKick = '1'; io.observe(v); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('pageshow', function(e){
    if (e.persisted){
      Array.prototype.slice.call(document.querySelectorAll('video[autoplay], video[data-jd-autoplay]')).forEach(function(v){
        if (inViewport(v)) kick(v);
      });
    }
    init();
  });
})();
